<!--
 * @Descripttion:
 * @version:
 * @Author: Jeson
 * @Date: 2021-06-07 09:41:25
 * @LastEditors: Jeson
 * @LastEditTime: 2022-01-13 14:24:01
-->
<template>
  <div v-if="dataImgItem && dataImgItem.length" id="home-ad-carousel-swipe">
    <a-carousel arrows autoplay :autoplay-speed="3000">
      <div
        slot="prevArrow"
        class="custom-slick-arrow"
        style="left: 50px; zindex: 1;"
      >
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow" class="custom-slick-arrow" style="right: 50px;">
        <a-icon type="right-circle" />
      </div>
      <div v-for="(item, index) in dataImgItem" :key="index">
        <img
          :src="item.MediaURL"
          width="100%"
          fit="cover"
          @click.stop="goRouter(item)"
        >
      </div>
    </a-carousel>
  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'HomeAdCarousel',
  mixins: [BaseMixin],
  data() {
    return {
      dataImgItem: [],
      loading: true
    }
  },
  mounted() {},
  methods: {
    init(dataImgItem) {
      // console.log(dataImgItem);
      this.dataImgItem = dataImgItem
      this.loading = false
      this.$forceUpdate()
    },
    goRouter(item) {
      console.log(item)
      this._jump(
        this._getTurnUrl(item.LinkType, item.LinkValue),
        item.LinkValue
      )
    }
  }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/color.less');

#home-ad-carousel-swipe {
  .swipe {
    text-align: center;
  }
}

.ant-carousel {
  .slick-slide {
    overflow: hidden;
    height: 160px;
    text-align: center;
    background: #364D79;
    line-height: 160px;
  }

  .custom-slick-arrow {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: #FFFFFF;
    background-color: rgba(31, 45, 61, .3);
    opacity: .5;
  }

  .custom-slick-arrow::before {
    display: none;
  }

  .custom-slick-arrow:hover {
    opacity: .5;
  }

  .slick-slide h3 {
    color: #FFFFFF;
  }

  .slick-prev:hover,
  .slick-next:hover {
    color: #FFFFFF;
    background: rgba(31, 45, 61, .3);
  }
}
</style>
